// Display Flow preparation issues without blocking persistence of authored content.
import React from 'react';
export default function FlowFieldErrors({ errors }) {
  if (!errors.length) return null;
  return (
    <div role="alert" className="ui visible warning message">
      <strong>These fields need attention before a WhatsApp Flow can be prepared. You can still save your changes.</strong>
      <ul>
        {errors.map((error) => (
          <li key={error}>{error}</li>
        ))}
      </ul>
    </div>
  );
}
